export function filterPizzaNouveaute(map) {
  map = map.filter((value) => {
    return value.Nouveaute;
  });
  return map;
}
